// extracted by mini-css-extract-plugin
export default {"categoryLink":"Xs1Xsl","categoryLinkFirstItem":"rKFCEa"};